import { styled,Box } from '@mui/system';


export const MainContainer = styled(Box)(({
  margin : '16px 80px 80px 80px',
}));

export const Title = styled(Box)(({ theme }) => ({
  color      : theme.palette.primary.gray8,
  fontFamily : 'Montserrat',
  fontStyle  : 'normal',
  fontWeight : 700,
  fontSize   : '32px',
  lineHeight : '42px',
}));

export const CheckboxLabel = styled(Box)(({ theme }) => ({
  color      : theme.palette.primary.black,
  fontFamily : 'Montserrat',
  fontStyle  : 'normal',
  fontWeight : 400,
  fontSize   : '14px',
  lineHeight : '24px',
}));

export const Text = styled(Box)(({ theme }) => ({
  color      : theme.palette.primary.black1,
  fontFamily : 'Montserrat',
  fontStyle  : 'normal',
  fontWeight : 400,
  fontSize   : '14px',
  lineHeight : '24px',
  marginTop  : '16px',
  maxWidth   : '659px',
}));

export const CategoryHeader = styled(Box)({
  minWidth   : '350px',
  font       : 'Montserrat',
  fontWeight : 'bold',
  weight     : '700',
  size       : '12px',
  height     : '20px',
});

export const CustomCategoryHeader = styled(Box)({
  minWidth   : '175px',
  font       : 'Montserrat',
  fontWeight : 'bold',
  weight     : '700',
  size       : '12px',
  height     : '20px',
  display    : 'flex',
  marginTop  : '28px',
});

export const Breadcrumb = styled(Box)({
  display    : 'flex',
  alignItems : 'center',
  gap        : '10px',
  a          : {
    textDecoration : 'none',
  },
  marginTop    : '28px',
  marginBottom : '24px',
});
